import { Component, Element, Host, h, Prop } from "@stencil/core";

/**
 * This component displays a content header with image, headline, text and
 * optional call-to-action (CTA) elements and badge.
 *
 * @slot headline - Slot for the headline element (`<h1>` recommended)
 * @slot image - Slot for the image element (e.g. `<img>`, `<picture>`)
 * @slot text - Slot for the text element (e.g. `<p>`, `<div>`)
 * @slot cta - Slot for call-to-action elements (e.g. `<ux-button>`)
 * @slot badge - Slot for a badge element (`<ux-eyecatcher>`)
 */
@Component({
    tag: "ux-iws-content-header",
    styleUrl: "content-header.scss",
    shadow: false,
})
export class ContentHeader {
    private baseClass = "ux-iws-content-header";

    /** The host element */
    @Element() host!: HTMLUxIwsContentHeaderElement;

    /** Headline of the module
     * @deprecated Use the headline slot instead
     */
    @Prop() headline: string = null;

    /** If set, the content box will be aligned to the left. */
    @Prop() boxLeft?: boolean = false;

    render() {
        const hasHeadlineSlot = !!this.host.querySelector("[slot='headline']");
        return (
            <Host class={this.baseClass}>
                <slot name="image" />
                <slot name="badge" />
                <div
                    class={{
                        [`${this.baseClass}__box ux-col-md-10 ux-u-mx-md-auto`]: true,
                        [`${this.baseClass}__box--left ux-col-xl-4`]:
                            this.boxLeft,
                    }}
                >
                    <div
                        class={{
                            [`ux-col-md-10 ux-u-mx-auto`]: true,
                            [`ux-col-md-12`]: this.boxLeft,
                        }}
                    >
                        {!hasHeadlineSlot && this.headline && (
                            <h1 class="headline-big ux-u-mb-xxxs">
                                {this.headline}
                            </h1>
                        )}
                        <slot name="headline" />
                        <slot name="text" />
                        <slot name="cta" />
                    </div>
                </div>
            </Host>
        );
    }
}
